import { render } from "./TeachingPlanSupportPanel.vue?vue&type=template&id=73328ca8&scoped=true&ts=true"
import script from "./TeachingPlanSupportPanel.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanSupportPanel.vue?vue&type=script&lang=ts"

import "./TeachingPlanSupportPanel.vue?vue&type=style&index=0&id=73328ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73328ca8"]])

export default __exports__